<template>
    <div class="flex items-center">
        <button
            :id="props.vid"
            type="button"
            class="flex gap-x-2"
            @click="handleChange(value ? value : !value)"
        >
            <slot v-bind="{ checked }">
                <div
                    :value="checked"
                    :class="{
                        'border-brand bg-brand': checked,
                        'border-muval-gray-4 bg-white': !checked,
                    }"
                    class="relative flex h-5 w-5 items-center rounded border shadow-muval-5 transition focus:outline-none focus-visible:outline-none dark:border-gray-600 dark:bg-gray-700 dark:ring-offset-gray-800 dark:hover:ring-blue-600 dark:focus:ring-blue-600"
                >
                    <SvgIcon
                        name="system-check"
                        class="m-auto size-5 text-white"
                        :class="!checked ? 'hidden' : ''"
                    />
                </div>
                <span
                    v-if="label"
                    class="text-sm"
                    v-text="label"
                />
            </slot>
        </button>
    </div>
</template>

<script setup>
import { useField } from 'vee-validate';
import { idGen } from '@/utilities/idGen';

const props = defineProps({
    modelValue: {
        type: null,
        required: true,
    },
    vid: {
        type: String,
        required: false,
        default: () => idGen(6),
    },
    value: {
        type: String,
        required: false,
        default: null,
    },
    label: {
        type: String,
        required: false,
        default: null,
    },
});

const { vid } = toRefs(props);

const { checked, handleChange } = useField(vid.value || '', undefined, {
    type: 'checkbox',
    checkedValue: props.value || true,
    uncheckedValue: props.value ? null : false,
    syncVModel: true,
});
</script>

<style scoped>
button {
    background: none;
    border: none;
    font-size: 22px;
}
</style>
